import { isFolder } from 'hb-react/shared/utils/files/fileContentTypes';

export const formatFileExtension = (file) => {
  if (file?.extension) {
    return file.extension;
  }

  if (file?.content_type) {
    if (file.content_type.match(/\/png$/)) {
      return 'png';
    }

    if (file.content_type.match(/(\/jpg$)|(\/jpeg$)/)) {
      return 'jpg';
    }

    if (file.content_type.match(/\/pdf$/)) {
      return 'pdf';
    }

    if (isFolder(file.content_type)) {
      return s__('Portfolio|folder');
    }
  }

  return s__('Portfolio|file');
};
